import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { CADRINO_HR_LOGO_ASPECT_RATIO, CADRINO_HR_LOGO_FOR_DARK_BG, CADRINO_HR_LOGO_FOR_LIGHT_BG } from '@/lib/brand/brand-assets';
import { cn } from '@/lib/utils';
type CadrinoHrLogoVariant = 'forDarkBg' | 'forLightBg';
const srcByVariant = {
  forDarkBg: CADRINO_HR_LOGO_FOR_DARK_BG,
  forLightBg: CADRINO_HR_LOGO_FOR_LIGHT_BG
} as const;
type CadrinoHrLogoProps = {
  variant: CadrinoHrLogoVariant;
  href?: string;
  height?: number;
  className?: string;
};
export function CadrinoHrLogo(t0) {
  const $ = _c(16);
  const {
    variant,
    href,
    height: t1,
    className
  } = t0;
  const height = t1 === undefined ? 24 : t1;
  let t2;
  if ($[0] !== height) {
    t2 = Math.round(height * CADRINO_HR_LOGO_ASPECT_RATIO);
    $[0] = height;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const width = t2;
  const t3 = srcByVariant[variant];
  let t4;
  if ($[2] !== className) {
    t4 = cn("max-w-none object-contain object-left", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== height || $[5] !== width) {
    t5 = {
      width,
      height
    };
    $[4] = height;
    $[5] = width;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== height || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== width) {
    t6 = <Image src={t3} alt="Cadrino HR" width={width} height={height} className={t4} style={t5} />;
    $[7] = height;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = width;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const image = t6;
  if (!href) {
    return image;
  }
  let t7;
  if ($[13] !== href || $[14] !== image) {
    t7 = <Link href={href} className="inline-flex shrink-0 rounded-sm">{image}</Link>;
    $[13] = href;
    $[14] = image;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}